import { render } from "./DevicePage.vue?vue&type=template&id=dfd2ae52"
import script from "./DevicePage.vue?vue&type=script&lang=js"
export * from "./DevicePage.vue?vue&type=script&lang=js"
script.render = render

export default script